import { FormAutoSaverService } from './services/FormAutoSaverService';
import { API } from './api/API';
import { LoggingService } from './services/LoggingService';

type RisenHopeEnvironment = {
  api: API;
  services: {
    logger: LoggingService;
    formAutoSaver: FormAutoSaverService;
  };
};

let _currentEnvironment: RisenHopeEnvironment | undefined = undefined;

const Environment = {
  current(): RisenHopeEnvironment {
    return { ..._currentEnvironment! };
  },
  set(environment: RisenHopeEnvironment) {
    if (_currentEnvironment === undefined) {
      _currentEnvironment = environment;
    }
  },
};

Object.freeze(Environment);
export { Environment };
